import { z } from "zod";

export const rescheduleSchema = z.object({
  due_date: z.string().min(1, "Informe a nova data"),
});

export type RescheduleFormData = z.infer<typeof rescheduleSchema>;
